import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ManualApplicationFileSearchParams, RequestStrategyEnum } from '@shared/api';

interface IRejectManualApplicationFileStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  rejectManualApplicationFile: (searchParams: ManualApplicationFileSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRejectManualApplicationFileStore = create<IRejectManualApplicationFileStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  rejectManualApplicationFile: ApiUtils.wrapperApi(async (searchParams: ManualApplicationFileSearchParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.rejectManualApplicationFile(searchParams, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
